/**
 * Официальные соцсети игры — ссылки в подвале главного меню
 * (см. MainMenuSocialLinks). id уходит в аналитику кликов, поэтому менять
 * существующие не стоит — только добавлять новые.
 */
export const SOCIAL_LINK_ICONS = {
  TELEGRAM: '/img/icons/telegram.png',
  VK: '/img/icons/vk.png',
  YOUTUBE: '/img/icons/youtube.png',
};

export const SOCIAL_LINKS = [
  {
    id: 'youtube_channel',
    label: 'Канал на YouTube',
    url: 'https://www.youtube.com/@StrategikonGame',
    iconPath: SOCIAL_LINK_ICONS.YOUTUBE,
  },
  {
    id: 'telegram_chat',
    label: 'Чат игроков в Telegram',
    url: 'https://t.me/+nq9Anfw4yjRlMDQy',
    iconPath: SOCIAL_LINK_ICONS.TELEGRAM,
  },
  {
    id: 'telegram_news',
    label: 'Новости в Telegram',
    url: 'https://t.me/+A-0fWyp8orllZjQy',
    iconPath: SOCIAL_LINK_ICONS.TELEGRAM,
  },
  {
    id: 'vk_news',
    label: 'Новости во ВКонтакте',
    url: 'https://vk.ru/strategikongame',
    iconPath: SOCIAL_LINK_ICONS.VK,
  },
];
